import styles from "./footer.module.scss";
export default function Footer() {
  return (
    <footer className={styles.footer}>
      &copy; 2025 Pluritongues LLC. All rights reserved.
    </footer>
  );
}
